module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start04-1a61110fbc9863dadb5b0151b09d4763.gif";